var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"eventos_wrapper_empty",staticStyle:{"background":"#EEEEEE","height":"100vh"}},[_c('div',{staticClass:"wrapper_middle"},[_c('img',{attrs:{"src":require('@/assets/images/loading.gif'),"width":"180"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }